import { render, staticRenderFns } from "./DeleteStatements.vue?vue&type=template&id=5598e83c"
import script from "./DeleteStatements.vue?vue&type=script&lang=js"
export * from "./DeleteStatements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports